// import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import SelfPayItem from "./SelfPayItem";

const SelfPayDetails = () => {
    const activeCase = useSelector(state => state.case.activeCase) 

    // const [data, setData] = useState(null)

    // useEffect(() => {
    //     if (activeCase) {            
    //         if (activeCase.selfpay) {
    //             let obj = {...activeCase.selfpay}

    //             setData(obj)
    //         }
            
    //     }
    // }, [activeCase])

    return <>
        {activeCase && activeCase.selfpay && <SelfPayItem itemData={activeCase.selfpay} apiCase={'case_selfpay'}/>}
    </>
}

export default SelfPayDetails